export enum AndieAgents {
    ONBOARDING = 'onboardingAgent',
    GENERAL = 'frontendGeneralAgent',
    CONTENT = 'contentAgent',
    INSIGHTS = 'insightsAgent',
}
